import { ISite } from '../../../helpers/typeHelpers';

export default [
  { label: 'Dealer settings', path: '/admin/dealer', showInMenu: true },
  { label: 'Configuration', path: '/admin/configuration', showInMenu: true },
  { label: 'Dealer Promotion', path: '/admin/configuration/create-promotion', showInMenu: false }
] as ISite[];
